import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Leia oma mööbel meie AI-otsinguga

  <span style="color:#85c1dc;">**FI:**</span>
  Löydä täydelliset kalusteet tekoälyn avulla

  <span style="color:#85c1dc;">**RU:**</span>
  Найди свою мебель с помощью нашего AI-поиска
*/
/* @__NO_SIDE_EFFECTS__ */
const m1484 = msg(
  mf`Leia oma mööbel meie AI-otsinguga`,
  mf`Löydä täydelliset kalusteet tekoälyn avulla`,
  mf`Найди свою мебель с помощью нашего AI-поиска`,
)

export { m1484 as 'w.module.try_new_search.title' }